// // src/layouts/submenuConfig.js
import {
  LayoutDashboard,
  Building2,
  Users,
  ClipboardList,
  CalendarCheck,
  Clock,
  Briefcase,
  Plane,
  Sun,
  FileText,
  BookOpen,
  GraduationCap,
  CalendarDays,
  UserRound,
  DollarSign,
  FileCheck,
  Wallet,
  ShieldCheck,
  Settings,
  BarChart3,
  FileArchive,
  Award, 
  Trophy,
  Fingerprint,
  Bell,
  FolderOpen,
  BookAudio,
  UserCheck,
  Cloud,
  PenLine,
  Stamp,
  Package,
} from 'lucide-react';

/** Thông tin hiển thị của từng module (dùng cho sidebar và breadcrumb ở header). */
export const moduleMeta = [
  { key: 'crm', label: 'CRM', icon: Users },
  { key: 'hrm', label: 'HRM', icon: Briefcase },
  { key: 'elearning', label: 'E-Learning', icon: BookOpen },
  { key: 'finance', label: 'Tài chính', icon: Wallet },
  { key: 'reports', label: 'Báo cáo', icon: BarChart3 },
  { key: 'settings', label: 'Cài đặt', icon: Settings, superOnly: true },
];

const submenu = {
  crm: [
    { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, featureCode: 'crm.dashboard', enabled: true },
    { key: 'customers', label: 'Khách hàng', icon: Users, featureCode: 'crm.customers', enabled: true },
    { key: 'teacher_accounts', label: 'Giáo viên đối tác', icon: GraduationCap, featureCode: 'crm.teacher_accounts', enabled: true },
    { key: 'contact_history', label: 'Lịch sử liên hệ', icon: FileText, featureCode: 'crm.contact_history', enabled: true },
    { key: 'contracts', label: 'Hợp đồng', icon: FileCheck, featureCode: 'crm.contracts', enabled: true },
    { key: 'documents', label: 'Hồ sơ liên kết', icon: FolderOpen, featureCode: 'crm.documents', enabled: true }, // Hồ sơ, chứng từ liên quan hợp đồng
    { key: 'events', label: 'Sự kiện', icon: CalendarDays, featureCode: 'crm.events', enabled: false }, // SỰ KIỆN (chưa phát triển)    
    { key: 'calendar', label: 'Lịch nhắc hẹn', icon: Clock, featureCode: 'crm.calendar', enabled: false }, // LỊCH NHẮC HẸN (calendar)
  ],
  
  hrm: [
    { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, featureCode: 'hrm.dashboard', enabled: true },
    { key: 'branches', label: 'Chi nhánh', icon: Building2, featureCode: 'hrm.branches', enabled: true },
    { key: 'employees', label: 'Nhân viên', icon: Users, featureCode: 'hrm.employees', enabled: true },
    { key: 'plans', label: 'Kế hoạch', icon: ClipboardList, featureCode: 'hrm.plans', enabled: true },
    { key: 'tasks', label: 'Công việc', icon: ClipboardList, featureCode: 'hrm.tasks', enabled: true },
    { key: 'hrm_attendance', label: 'Chấm công', icon: Fingerprint, featureCode: 'hrm.attendance', enabled: true },
    { key: 'overtime', label: 'Tăng ca', icon: Clock, featureCode: 'hrm.overtime', enabled: true },
    { key: 'business_trip', label: 'Công tác', icon: Plane, featureCode: 'hrm.business_trip', enabled: true },
    { key: 'on_leave', label: 'Nghỉ phép', icon: Sun, featureCode: 'hrm.on_leave', enabled: true },
    { key: 'my_payslip', label: 'Xem bảng lương', icon: DollarSign, featureCode: 'hrm.my_payslip', enabled: true },
    { key: 'hrm_documents', label: 'Thư viện tài liệu', icon: FileArchive, featureCode: 'hrm.documents', enabled: true },
    { key: 'signing', label: 'Trình ký', icon: PenLine, featureCode: 'hrm.signing', enabled: true },
  ],

  elearning: [
    { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, featureCode: 'elearning.dashboard', enabled: true },
    { key: 'edu_documents', label: 'Tài liệu học tập', icon: FileText, featureCode: 'elearning.documents', enabled: true },
    { key: 'subjects', label: 'Môn học', icon: BookAudio, featureCode: 'elearning.subjects', enabled: true },
    { key: 'courses', label: 'Khóa học', icon: BookOpen, featureCode: 'elearning.courses', enabled: true },
    { key: 'lessons', label: 'Bài học', icon: ClipboardList, featureCode: 'elearning.lessons', enabled: true },
    { key: 'classes', label: 'Lớp học', icon: GraduationCap, featureCode: 'elearning.classes', enabled: true },
    { key: 'students', label: 'Học viên', icon: UserRound, featureCode: 'elearning.students', enabled: true },
    { key: 'edu_attendance', label: 'Điểm danh', icon: UserCheck, featureCode: 'elearning.attendance', enabled: true },
    { key: 'results', label: 'Kết quả học tập', icon: Trophy, featureCode: 'elearning.results', enabled: true },
    { key: 'calendar', label: 'Thời khóa biểu', icon: CalendarDays, featureCode: 'elearning.calendar', enabled: true }, 
    { key: 'certificates', label: 'Giấy chứng nhận', icon: Award, featureCode: 'elearning.certificates', featureCodes: ['elearning.certificates', 'elearning.certificates.request'], enabled: true },
  ],

  finance: [
    { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, featureCode: 'finance.dashboard', enabled: true },
    { key: 'advance', label: 'Đề nghị tạm ứng', icon: Wallet, featureCode: 'finance.advance.access', enabled: true },
    { key: 'payment_requests', label: 'Đề nghị thanh toán', icon: FileCheck, featureCode: 'finance.payment_requests', enabled: true }, // developing
    { key: 'course_fee', label: 'Bảng giá khóa học', icon: DollarSign, featureCode: 'finance.course_fee', enabled: false }, // chưa thiết kế
    { key: 'payment', label: 'Nhắc nợ học viên', icon: DollarSign, featureCode: 'finance.payment', enabled: false }, // chưa thiết kế
    { key: 'salary', label: 'Lương nhân sự', icon: DollarSign, featureCode: 'finance.salary', enabled: true },
    { key: 'income_expenditure', label: 'Quản lý thu-chi', icon: Wallet, featureCode: 'finance.income_expenditure', enabled: true },
    { key: 'invoices', label: 'Quản lý hóa đơn', icon: FileText, featureCode: 'finance.invoices', enabled: true },
  ],

  reports: [
    { key: 'reports_tasks', label: 'Công việc hàng ngày', icon: ClipboardList, featureCode: 'reports.tasks', enabled: true },
    { key: 'finance_cashflow', label: 'Dòng tiền thu–chi', icon: Wallet, featureCode: 'reports.finance', enabled: true },
    { key: 'finance_collections', label: 'Thu tiền & công nợ', icon: FileText, featureCode: 'reports.finance', enabled: true },
  ],
  settings: [
    { key: 'usage_roles', label: 'Quyền sử dụng', icon: ShieldCheck, featureCode: 'settings.usage_roles', enabled: true },
    { key: 'user_access', label: 'Kiểm tra quyền tài khoản', icon: Users, featureCode: 'settings.usage_roles', enabled: true },
    { key: 'user_roles', label: 'Gán quyền nhân viên', icon: Users, featureCode: 'settings.user_roles', enabled: true },
    { key: 'roles', label: 'Quản lý vai trò (nâng cao)', icon: ShieldCheck, featureCode: 'settings.roles', enabled: false },
    { key: 'permissions', label: 'Quản lý quyền (nâng cao)', icon: ShieldCheck, featureCode: 'settings.permissions', enabled: false },
    { key: 'role_permissions', label: 'Ma trận phân quyền (nâng cao)', icon: ShieldCheck, featureCode: 'settings.role_permissions', enabled: false },
    { key: 'notifications', label: 'Quản lý thông báo', icon: Bell, featureCode: 'system.manage_notify', enabled: true },
    { key: 'signature_assets', label: 'Chữ ký & con dấu', icon: Stamp, featureCode: 'settings.signature_assets', enabled: true },
    { key: 'app_versions', label: 'Phiên bản sử dụng', icon: Package, featureCode: 'system.version', enabled: true },
    { key: 'login_log', label: 'Lịch sử đăng nhập', icon: Clock, featureCode: 'settings.login_log', enabled: false },
    { key: 'gcs_cost', label: 'GCS management', icon: Cloud, featureCode: 'elearning.documents', enabled: true },
  ],
};

export default submenu;
